export default __webpack_public_path__ + "static/media/challenge-power.f4a8b5c8.svg";